/* global $:true */
import ally from 'ally.js';

$(document).ready(() => {
	ally.style.focusSource();
});
